import { Component, inject } from '@angular/core';
import { DialogHeaderComponent } from '../../components/dialog-header/dialog-header.component';
import { NewActionButtonComponent } from '../../components/new-action-button/new-action-button.component';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule, TriangleAlert } from 'lucide-angular';
import { TaskReoccurs } from 'src/models/task.model';
import { DialogPayload } from 'src/services/dialog.service';

export interface ScheduleEnabledSettingsPayload {
  reocurrence: TaskReoccurs;
  isTaskSet: boolean;
  isAssignedRole: boolean;
  isBackDated: boolean;
  profileName: string;
}

@Component({
  selector: 'app-schedule-enabled-settings',
  imports: [
    DialogHeaderComponent,
    NewActionButtonComponent,
    DatePipe,
    MatRadioModule,
    FormsModule,
    LucideAngularModule,
  ],
  templateUrl: './schedule-enabled-settings.dialog.html',
  styleUrl: './schedule-enabled-settings.dialog.scss',
})
export class ScheduleEnabledSettingsDialog {
  protected readonly params =
    inject<DialogPayload<ScheduleEnabledSettingsPayload>>(MAT_DIALOG_DATA);
  protected readonly dialogRef = inject(MatDialogRef<ScheduleEnabledSettingsDialog>);
  protected TriangleAlert = TriangleAlert;
  protected isTaskSet = this.params.payload.isTaskSet;
  protected reocurrence = this.params.payload.reocurrence;
  protected isAssignedRole = this.params.payload.isAssignedRole;
  protected title = `Schedule ${this.isTaskSet ? 'Task Set' : 'Task'} Settings`;
  protected isBackDated = this.params.payload.isBackDated;
  protected now = new Date();
  protected profileName = this.params.payload.profileName;

  protected onSave = () => {
    this.dialogRef.close(this.reocurrence);
  };
}
